export const addresses = {
  storeAddress:"0xC32609C91d6B6b51D48f2611308FEf121B02041f",
  tokenAddress:"0x262e2b50219620226C5fB5956432A88fffd94Ba7"
}
